import React from 'react'
import PropTypes from 'prop-types'
import TextField from '../../shared/components/fields/textField/TextField';
import logo from './../../shared/img/innlink_logo_login_page.svg';
import './../styles.scss'
import PasswordFieldContainer from './../../shared/components/fields/passwordField/PasswordFieldContainer';
import { I18n } from 'react-redux-i18n';
import _ from "../../shared/utils/ObjectUtils";

const Login = ({
    userFormData,
    handleFormDataChanged,
    handleFieldBlur,
    loadingLoginRequest: loading,
    loginError: error,
    login,
    handleForgotPasswordButtonClicked,
    handleResetPasswordButtonClicked,
    disabled
}) => (
        <div className="fill">
            <div>
                {disabled &&
                    <div
                        className="blocked-content"
                        onClick={() => {
                            handleForgotPasswordButtonClicked(false);
                            handleResetPasswordButtonClicked(false);
                        }}
                    />}
            </div>
            <div className="login-title">
                <img className="img-fluid" alt="logo" src={logo} />
            </div>
            <div
                className="login-form"
                onKeyPress={e => handleLoginOnEnterKeyPressed(e.key, login, loading, userFormData)}
            >
                <TextField
                    classes={" mb-3"}
                    value={userFormData.email.value}
                    label={I18n.t('email')}
                    handleFieldChange={value => handleFormDataChanged(value, "email")}
                    handleFieldBlur={() => handleFieldBlur("email")}
                    error={userFormData.email.error}
                    autofocus={true}
                    themeName={"white"}
                    width={12}
                />
                <PasswordFieldContainer
                    value={userFormData.password.value}
                    label={I18n.t('password')}
                    handleFieldChange={value => handleFormDataChanged(value, "password")}
                    handleFieldBlur={() => handleFieldBlur("password")}
                    error={userFormData.password.error}
                    themeName={"white"}
                    width={12}
                />
                <span className="error-text">
                    {error}
                </span>
                <button
                    onClick={login}
                    className="login-btn btn d-block mx-auto"
                    disabled={
                        loading || 
                        userFormData.email.error || 
                        userFormData.password.error ||
                        _.isNilOrEmpty(userFormData.email.value) || 
                        _.isNilOrEmpty(userFormData.password.value)
                    }
                >
                    {loading ? I18n.t('forms.loading') : I18n.t("auth.login")}
                </button>
                <button
                    className="forgot-password-btn d-block mx-auto py-5"
                    onClick={() => handleForgotPasswordButtonClicked(true)}
                >
                    {I18n.t('auth.forgotPasswordButton')}
            </button>
            </div>
        </div>
    );

function handleLoginOnEnterKeyPressed(key, login, loading, userFormData){
    if(key === "Enter" && !(loading || userFormData.email.error || userFormData.password.error ||
        _.isNilOrEmpty(userFormData.email.value) || _.isNilOrEmpty(userFormData.password.value))) {
        login();
    }
}

Login.propTypes = {
    userFormData: PropTypes.shape({
        email: PropTypes.shape({
            value: PropTypes.string.isRequired,
            error: PropTypes.string
        }),
        password: PropTypes.shape({
            value: PropTypes.string.isRequired,
            error: PropTypes.string
        }),
    }),
    userLoggedIn: PropTypes.bool,
    error: PropTypes.string,
    loading: PropTypes.bool,
    login: PropTypes.func.isRequired,
    logout: PropTypes.func
};

export default Login;